<template>
<gj-modal class="reply-off-site-mailbox-add-mail" :visible.sync="modalVisible" size="700XAuto">
    <template #header>收件人</template>
    <template #content>
      <gj-table
        ref="gjTable"
        :name="tableName"
        :data="tableData"
        :columns="columns"
      >
  </gj-table>
    </template>
</gj-modal>

</template>
<script>
import { modalMixIn } from './../../../../../../minxins';
export default {
  mixins: [modalMixIn],
  props:{
    tableData:Array
  },
  data() {
    return {
     tableName:"userTable",
     columns:[
       {
          id: 'name',
          header: 'name',
          field: 'name',
        },
        {
          id: 'email',
          header: 'email',
          field: 'email',
        },
        {
          id: 'ext1',
          header: 'ext1',
          field: 'ext1',
        },
        {
          id: 'ext2',
          header: 'ext2',
          field: 'ext2',
        },
        {
          id: 'ext3',
          header: 'ext3',
          field: 'ext3',
        },
     ]
    }
  }
}
</script>
